import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAnswer } from '../../actions/questionActions';
import es from 'date-fns/locale/es';
import { registerLocale } from 'react-datepicker';

registerLocale('es', es);
const Fecha = ({ title, idPregunta }) => {
    const dispatch = useDispatch();
    const answers = useSelector(state => state.question.answers);
    const reduxValue = answers[idPregunta]?.answer || '';
    // Estado local para la fecha
    const [selectedDate, setSelectedDate] = useState(reduxValue ? new Date(reduxValue) : null);

    // Solo sincroniza cuando cambia la pregunta
    useEffect(() => {
        setSelectedDate(reduxValue ? new Date(reduxValue) : null);
    }, [idPregunta]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        dispatch(setAnswer(idPregunta, date));
    };

    return (
        <div className="form-group mt-3" id='form-group-datapicker'>
            <label className='form-check-label' style={{paddingRight:'15px'}}> {title} </label>
            <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                showTimeSelect={false}
                dateFormat="yyyy-MM-dd"
                locale="es"
                className="custom-datepicker"
            />
        </div>
    );
};

export default Fecha;
